import {gestioneTabs, nngTabs} from "../../util/constants";
import {numeriSpecialiPapers} from "./NngHelper";
import useSessionStorage from "../../util/hooks/useSessionStorage";
import {useEffect, useRef, useState} from "react";
import {useDispatch} from "react-redux";
import {clearStoricoTableData} from "../../store/storico-configurazioni/actions";

const useNng = () => {
    const dispatch = useDispatch()
    const [pageState, setPageState] = useState(numeriSpecialiPapers);
    const [selectedTab, setSelectedTab] = useSessionStorage(
        "nng-tab-group",
        nngTabs.ASSOCIAZIONE
    );
    const [numeriSelectedTab, setNumeriSelectedTab] = useSessionStorage(
        "numeri-neri-tabs-subgroup",
        0
    );
    const [isDuplica, setIsDuplica] = useState(false);
    const firstRenderStorico = useRef(true)

    useEffect(() => {
        if(!firstRenderStorico.current) {
          firstRenderStorico.current = true
          dispatch(clearStoricoTableData())
        }
    }, [dispatch, selectedTab]);

    const handleSelectTab = (value, nsId) => {
        if (value === gestioneTabs.GESTIONE_NUMERI_NERI) {
            setNumeriSelectedTab(0);
            setIsDuplica(false);
        }
        setSelectedTab(value);
        setPageState((oldState) =>
            oldState.map((os) =>
                os.id === nsId ? {...os, expanded: !os.expanded} : os
            )
        );
    };

    const handleAccordionChange = (e, ex, nsId) => {
        setPageState((oldState) =>
            oldState.map((os) =>
                os.id === nsId ? {...os, expanded: !os.expanded} : os
            )
        );
    };

    return [
        pageState,
        selectedTab,
        handleSelectTab,
        handleAccordionChange,
        numeriSelectedTab,
        setNumeriSelectedTab,
        isDuplica,
        setIsDuplica,
        firstRenderStorico
    ];
};

export default useNng;
